import CreateWindow from "../puzzleWindow";
import "./index.css";
import { html, render } from "lit-html";
import Pohja from "./pohja.jpg";
import TuntiViisari from "./tuntiviisari.png";
import MinuuttiViisari from "./minuuttiviisari.png";
import throttle from "~src/helpers/throttle.js";
import { userChoiceTracker } from "~src/helpers/userChoiceTracker";
import { tips, TipWindow } from "~src/tips/index.js";
import { mobileOrNot } from "~/src/helpers/mobileDetect.js";
import { exitButtonPosition } from "../../helpers/exitButtonPosition"


function getCurrentRotation(el) {
  if (!el) return;
  var st = window.getComputedStyle(el, null);
  var tm =
    st.getPropertyValue("-webkit-transform") ||
    st.getPropertyValue("-moz-transform") ||
    st.getPropertyValue("-ms-transform") ||
    st.getPropertyValue("-o-transform") ||
    st.getPropertyValue("transform") ||
    "none";
  if (tm != "none") {
    var values = tm.split("(")[1].split(")")[0].split(",");
    var angle = Math.round(Math.atan2(values[1], values[0]) * (180 / Math.PI));
    return angle < 0 ? angle + 360 : angle; //adding 360 degrees here when angle < 0 is equivalent to adding (2 * Math.PI) radians before
  }
  return 0;
}

let oldAngle = 0;

let BgLoaded;

let exitClicks = 0;

const FlatPuzzle = function (doorTrigger) {

let downEvent = mobileOrNot() ? "touchstart" : "mousedown";
let upEvent = mobileOrNot() ? "touchend" : "mouseup";
let moveEvent = mobileOrNot() ? "touchmove" : "mousemove";
  const markup = html`
    <div
      class="container clock-puzzle"
      style="display: flex;justify-content: center;align-items: center; margin: auto"
    >
      <div class="clock-container">
        <img
          class="clock select-disable"
          draggable="false"
          src=${Pohja}
          @load=${() => {
            BgLoaded = true;
            FlatPuzzle();
          }}
        />

        <img
          class="hour select-disable"
          draggable="false"
          id="clock-hour"
          src=${TuntiViisari}
        />
        <img
          class="minute select-disable"
          draggable="false"
          id="clock-minute"
          src=${MinuuttiViisari}
        />
      </div>
    </div>
  `;

  // CreateWindow palauttaa modaali-ikkunan noden, johon siis rendataan
  const puzzleWindow = CreateWindow({
    hidden: !BgLoaded,
    border: false,
    exitCallback: () => {
      exitClicks++;
      if (exitClicks === 1) {
        tips.solveClock1.setTime(1);
      }

      if (exitClicks === 2) {
        tips.solveClock1.clear();
        tips.solveClock2.setTime(1);
      }
      document
        .querySelector("#modal")
        .appendChild(document.querySelector(".exit-button"));
    },
  });

  const exitFromModal = puzzleWindow.exit

  render(markup, puzzleWindow.element);
  document
    .querySelector(".clock-container")
    .appendChild(document.querySelector(".exit-button"));

  let center;
    exitButtonPosition();
  const calculateCenter = () => {
    const container = document.querySelector(".clock-container");

    return {
      x: container.getBoundingClientRect().left + container.clientWidth / 2,
      y: container.getBoundingClientRect().top + container.clientHeight / 2,
    };
  };

  let anotherPoint;

  let angle = (anchor, point) =>
    (Math.atan2(anchor.y - point.y, anchor.x - point.x) * 180) / Math.PI + 180;

  var minuteHand = null;
  var hourHand = null;
  var isMouseDown = false;

  let prevHours = 0;
  let prevMins = 0;
  let passesZero = 0;
  let prevPassesZero = 0;

  const clock = document.querySelector(".clock-puzzle");
  let soundInterval;
  // do setTimeout to prevent event bubbling
  window.setTimeout(() => {
    clock.addEventListener(
      downEvent,
      function (event) {
        if(event.target.classList.contains("exit-button")) exitFromModal();
        event.preventDefault();
        passesZero = 0;
        prevHours = 0;
        prevMins = 0;
        isMouseDown = true;
        hourHand = document.getElementById("clock-hour");
        minuteHand = document.getElementById("clock-minute");
        minuteHand.classList.remove("animation");
        hourHand.classList.remove("animation");
      },
      true
    );

    clock.addEventListener(
      upEvent,
      function (e) {
        const minuteValue = getCurrentRotation(minuteHand);
        const hourValue = getCurrentRotation(hourHand);
        if (
          147 < minuteValue &&
          minuteValue < 153 &&
          270 < hourValue &&
          hourValue < 290
        ) {
          let animationSound = window.scene.getSoundByName("clockAnimation")
          animationSound?.dispose();
          userChoiceTracker.clockPuzzleResolved();
          console.log(doorTrigger)
          if (doorTrigger) doorTrigger();
          puzzleWindow.exit();
        } else {
          if(!mobileOrNot()) {
          setTimeout( () => {
          let animationSound = window.scene.getSoundByName("clockAnimation")
          animationSound?.play();
          }, 1000)
        }
          minuteHand.classList.add("animation");
          hourHand.classList.add("animation");
          minuteHand.style.transform = `rotate(1800deg)`;
          hourHand.style.transform = `rotate(-1800deg)`;
          hourHand, (minuteHand = null);
        }
        isMouseDown = false;
      },
      true
    );
  }, 1000);
  let previousDegreePosition;
  let checkpointValues = [
    30,
    60,
    90,
    120,
    150,
    180,
    210,
    240,
    270,
    300,
    330,
    360,
  ];
  let checkpoints = checkpointValues;
  function diff(a, b) {
    return Math.abs(a - b);
  }
  const mouseMove = (e) => {
    if (!isMouseDown) return;
    let center = calculateCenter();
    let clientX = mobileOrNot() ? e.touches[0].clientX : e.clientX;
    let clientY = mobileOrNot() ? e.touches[0].clientY : e.clientY;
    let point = { x: clientX, y: clientY };

    let newAngle = angle(center, point) + 90;

    let turnToNumber = parseInt(JSON.stringify(newAngle), 10);
    if (turnToNumber > 360) turnToNumber = turnToNumber - 360;

    let rotateMins = turnToNumber - 0;
    let rotateHours = rotateMins / 12;

    const minutesRotateDecreased = prevMins > rotateMins;
    const zeroCountDown = prevPassesZero > passesZero;
    const hourRotateDecreased = prevHours > rotateHours;
    const hourRotateIncreased = prevHours < rotateHours;

    const hugeAbsoluteDifference =
      Math.abs(Math.abs(prevMins) - Math.abs(rotateMins)) > 200;

    let backwards = false;
    if (minutesRotateDecreased || zeroCountDown) backwards = true;

    if (hourRotateDecreased && hugeAbsoluteDifference) {
      checkpoints = [...checkpointValues];
      passesZero++;
    }
    if (hourRotateIncreased && hugeAbsoluteDifference) passesZero--;

    if (
      !mobileOrNot() &&
      turnToNumber > checkpoints[0] &&
      diff(checkpoints[0], turnToNumber) <= 30
    ) {
      checkpoints.shift();
      if (!window.scene.getSoundByName("clockMinutes")?.isPlaying) {
        window.scene.getSoundByName("clockMinutes")?.play();
      }
    }
    prevPassesZero = passesZero;

    minuteHand.style.transform = `rotate(${rotateMins}deg)`;
    hourHand.style.transform = `rotate(${passesZero * 30 + rotateHours}deg)`;
    prevHours = rotateHours;
    prevMins = rotateMins;
    turnToNumber = 0;
    rotateMins = 0;
    rotateHours = 0;
  };

  clock.addEventListener(moveEvent, throttle(mouseMove, 10), false);
};

export default FlatPuzzle;
